<div class="getting-started-block">
  @if (startingCourse.courseThumbnailIconId) {
    <div class="course-hero">
      <p class="course-hero-eyebrow">{{ eyebrowLabel }}</p>
      <div class="course-hero__content">
        <div class="course-hero__media">
          <img [src]="startingCourse.thumbnailUrl" alt="">
        </div>
        <div class="course-hero__body">
          <div class="course-hero__meta">
            @if (startingCourse) {
              <app-course-enrollment-status [course]="startingCourse"></app-course-enrollment-status>
            }
            <app-retired-course [course]="startingCourse"></app-retired-course>
            <app-favourite-course
              [course]="startingCourse"
              [userId]="loggedInUserPublicId"
              (notifyParent)="handleFavouriteClick()">
            </app-favourite-course>
          </div>
          <h2 class="course-hero__title">{{ startingCourse.courseName }}</h2>
          <div class="course-hero__description" [innerHTML]="startingCourse.courseShortDescription"></div>
          <div class="course-progress" [attr.aria-label]="progressLabel + ' progress'">
            <div class="course-progress__track">
              <div class="course-progress__fill" [style.width.%]="progressPercent"></div>
            </div>
            <span class="course-progress__label">{{ progressLabel }}</span>
          </div>
        </div>
        <div class="course-hero__action">
          <a
            class="course-hero__cta submit-form-button"
            routerLink="/participants/courses/view-course/{{ startingCourse.courseRecordId }}">
            {{ ctaLabel }}
          </a>
        </div>
      </div>
    </div>
  }

  @if (startingCourse.courseThumbnailIconId == 0) {
    <div class="course-hero course-hero--empty" (click)="goToCourses()" tabindex="0" (keydown.enter)="goToCourses()">
      <i class="fa-solid fa-magnifying-glass empty-state-icon" aria-hidden="true"></i>
      <span class="empty-state-text">{{'chooseNextCourseText'|translate:translations}}</span>
    </div>
  }
</div>
